
<wiz-vgroup height="100%" gap=0>
  <!-- label-->

  <wiz-hgroup class="wiz-component-label" width="100%" *ngIf="wizShowLabel" gap="2" padding="0px 5px 0px 5px">
    <wiz-label #innerLabel [wizLabel]="wizLabel" [wizTextBehavior]="'truncate'"></wiz-label><!-- label -->
    <span #innerAsterisk *ngIf="wizMandatory" class='mandatory-class'
    >*</span><!-- asterisque -->
  </wiz-hgroup>

  <!-- switch -->
  <label class="switch toggle-switch" (click)="onClick($event)" tabindex="0" (keydown)="onKeyDown($event)"
              [ngClass]="{'switch-checked': wizChecked, 'innerfocus-class': !wizDisabled}">

      <!-- text or image inside the button -->
      <wiz-hgroup class="switch-background" width="100%" height="100%" gap=0 verticalAlign="center" *ngIf="!checkboxType">
        <wiz-hgroup gap=0 verticalAlign="center" width="100%" height="100%"
                    class="switch-label-text"
                    *ngIf="(!leftIcon && !rightIcon); else backElseblock ">

                    <span >{{leftTranslatedText}}</span>
                    <span >{{rightTranslatedText}}</span>
                </wiz-hgroup>

                <ng-template  #backElseblock >
                    <wiz-hgroup class="switch-label-image" gap=0 width="100%" height="100%">
                        <img  src={{leftIcon}} alt="icon" height="inherit"/>
                        <img  src={{rightIcon}} alt="icon" height="inherit"/>
                    </wiz-hgroup>
                </ng-template>
        </wiz-hgroup>


        <!-- the slider -->
        <wiz-hgroup #switchSlider class="switch-handle" (panmove)="onPanMove($event)"
                                                    (panstart)="onPanStart($event)"  (press)="onPress($event)"
                                                    (panend)="panEnd($event)"
                                                    [ngClass]="{'slider-pressed': sliderIsPressed,
                                                    'checked': wizChecked,
                                                    'left': !wizChecked,
                                                    'right': wizChecked }">

                <span *ngIf="(!leftIcon && !rightIcon); else sliderElseblock">{{getSelectedText()}}</span>
                <ng-template #sliderElseblock>
                     <img *ngIf="!wizChecked" alt="icon" src={{leftIcon}} height="inherit" />
                     <img *ngIf="wizChecked" alt="icon" src={{rightIcon}} height="inherit"/>
                </ng-template>
        </wiz-hgroup>
    </label>

</wiz-vgroup>

